import { css } from "@emotion/react";
import React from "react";
import { trackEvent } from "../../../js/shared/tracking/tracking";

export function UnderMaintenacePage() {
  trackEvent("MaintenancePage", { category: "Board", action: "opened" });

  return (
    <div style={{ height: "100%", display: "flex" }}>
      <div css={styles.container}>
        <h2>&#128679;Bulk Actions Power Up is under maintenance&#128679;</h2>
        <h3>&#128119;Please, come back later&#128119;</h3>
      </div>
    </div>
  );
}

const styles = {
  container: css`
    margin: auto;
    text-align: center;
    padding: 48px 18px;
  `,
};
